import { createSlice } from "@reduxjs/toolkit";

function loadAccessFromStorage() {
  try {
    const raw = localStorage.getItem("access");
    if (!raw) return [];
    const p = JSON.parse(raw);
    return Array.isArray(p) ? p.map(String) : [];
  } catch {
    return [];
  }
}

function emptyUser() {
  return {
    userid: "",
    name: "",
    email: "",
    role: "",
    access: [],
    adminId: "",
    profileImage: ""
  };
}

function loadUserFromLocalStorage() {
  try {
    return {
      userid: localStorage.getItem("userid") || "",
      name: localStorage.getItem("name") || "",
      email: localStorage.getItem("email") || "",
      role: localStorage.getItem("role") || "",
      access: loadAccessFromStorage(),
      adminId: localStorage.getItem("adminId") || "",
      profileImage: localStorage.getItem("profileImage") || ""
    };
  } catch {
    return emptyUser();
  }
}

function persistProfileFields({ name, profileImage }) {
  try {
    if (name != null) localStorage.setItem("name", String(name));
    if (profileImage !== undefined) {
      const img = String(profileImage || "").trim();
      if (img) localStorage.setItem("profileImage", img);
      else localStorage.removeItem("profileImage");
    }
  } catch {
    /* ignore */
  }
}

const initialState = {
  user: loadUserFromLocalStorage()
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action) {
      const payload = action.payload || {};
      state.user = {
        ...emptyUser(),
        ...payload,
        profileImage: String(payload.profileImage || "").trim()
      };
      persistProfileFields({
        name: state.user.name,
        profileImage: state.user.profileImage
      });
    },
    updateUserProfile(state, action) {
      const { name, profileImage } = action.payload || {};
      if (name != null) {
        state.user.name = String(name);
      }
      if (profileImage !== undefined) {
        state.user.profileImage = String(profileImage || "").trim();
      }
      persistProfileFields({
        name: name != null ? state.user.name : undefined,
        profileImage: profileImage !== undefined ? state.user.profileImage : undefined
      });
    },
    clearUser(state) {
      state.user = emptyUser();
      try {
        localStorage.removeItem("profileImage");
      } catch {
        /* ignore */
      }
    }
  }
});

export const { setUser, clearUser, updateUserProfile } = authSlice.actions;
export default authSlice.reducer;
